module.exports = __webpack_public_path__ + "img/invitePatients.12ba1271.png";